import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useSeedByEnvironment } from '@/hooks/discovery/seed';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useEnvironmentScope } from '../useEnvironmentScope';

export const useSeed = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { userId } = useEnvironmentScope();
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;

  const [{ fetching, error, data }] = useSeedByEnvironment({
    environmentId: validEnvironmentId,
    userId: userId as number | null,
    uniqueId: uniqueId?.raw ?? '',
    pause: uniqueId?.resourceType !== 'seed' || userId === 'loading',
  });

  const seedQuery = useMemo(() => {
    const appliedEdge = data?.environment.applied?.seeds.edges?.[0];
    return {
      fetching,
      error,
      data: { applied: appliedEdge?.node, adapterType: data?.environment.adapterType },
    };
  }, [fetching, error, data]);

  return seedQuery;
};
